// default
export const SYSTEM = 'system';

// action
const GET_SYSTEM_SUB_LIST = `${SYSTEM}/GET_SYSTEM_SUB_LIST`;
const GET_DISCIPLINE_LIST = `${SYSTEM}/GET_DISCIPLINE_LIST`;
// actions
export const actions = {
  GET_SYSTEM_SUB_LIST,
  GET_DISCIPLINE_LIST
};
